// import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import RestartAltTwoToneIcon from "@mui/icons-material/RestartAltTwoTone";
import useIsMobile from "../hooks/useIsMobile";
import StatsDashboard from "./statsScreen";
import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  IconButton,
  Stack,
  Paper,
  Divider,
  useTheme,
  alpha,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Badge,
  LinearProgress,
} from "@mui/material";
import {
  Refresh as RefreshIcon,
  TrendingUp as TrendingUpIcon,
  CheckCircle as CheckCircleIcon,
  HourglassEmpty as HourglassEmptyIcon,
  EventBusy as EventBusyIcon,
  ErrorOutline as ErrorOutlineIcon,
  SupportAgent as SupportAgentIcon,
  MoreVert as MoreVertIcon,
  FilterList as FilterListIcon,
  Download as DownloadIcon,
  Print as PrintIcon,
  Settings as SettingsIcon,
  Notifications as NotificationsIcon,
  CalendarMonth as CalendarMonthIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";


const Stats = (props) => {
  const { data, refreshStatsData, openData, openTime } = props;
  const isMobile = useIsMobile();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewType, setViewType] = useState("grid");
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
console.log(data,"////")
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Modal {...props} className="stats-modal">
        <Modal.Header>
          <Modal.Title className="w-100">
            <div className="d-flex justify-content-between w-100 align-items-center">
              {" "}
              <div className="w-100">
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={0}
                  sx={{ mb: 0, display:"flex" }}
                  justifyContent="space-between"
                  alignItems={{ xs: "flex-start", sm: "center" }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="between"
                    sx={{ marginBottom: "0px" }}
                  >
                    <Box
                      sx={{
                        width: 10,
                        height: 50,
                        borderRadius: 8,
                        background: "#8eccd2f5",
                        // background: '#cbeceff5',
                        marginBottom: "0px",
                        boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)",
                      }}
                    />
                    <Typography
                      variant="h5"
                      component={motion.h5}
                      initial={{ x: -20, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      fontWeight={500}
                      color="#495a69"
                      sx={{
                        letterSpacing: 0.2,
                        textShadow: "0 1px 2px rgba(0,0,0,0.05)",
                        marginBottom: "0px",
                      }}
                    >
                      Stats Information
                    </Typography>
                  </Stack>

                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    component={motion.div}
                    initial={{ x: 20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    marginTop={{ xs: "19px" }}
                    width={{ xs: "100%",md:"auto" }}
                    display={{ xs: "flex" }}
                    justifyContent={{xs:"center", md:"flex-end"}}
                    sx={{ marginBottom: "0px" }}
                  >
                    <Paper
                      elevation={0}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        px: 2,
                        py: 1,
                        borderRadius: 3,
                        bgcolor: alpha(theme.palette.primary.main, 0.08),
                        border: `1px solid ${alpha(
                          theme.palette.primary.main,
                          0.1
                        )}`,
                      }}
                    >
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ fontWeight: 600 }}
                      >
                        {openData} {" "} {openTime}
                      </Typography>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ mx: 1.5, height: 24 }}
                      />
                      <Tooltip title="Refresh data" arrow>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={refreshStatsData}
                          sx={{
                            bgcolor: theme.palette.background.paper,
                            boxShadow: `0 2px 8px ${alpha(
                              theme.palette.primary.main,
                              0.2
                            )}`,
                            cursor:"pointer",
                            "&:hover": {
                              bgcolor: theme.palette.background.paper,
                              boxShadow: `0 4px 12px ${alpha(
                                theme.palette.primary.main,
                                0.3
                              )}`,
                            },
                          }}
                        >
                          <RefreshIcon fontSize="small"/>
                        </IconButton>
                      </Tooltip>
                    </Paper>
                  </Stack>
                </Stack>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={
            isMobile
              ? { height: "55vh", overflow: "auto" }
              : { height: "67vh", overflow: "auto" }
          }
        >
          <StatsDashboard data={[{...data.overall,status:"Overall"},...data.stats]} />
          {/* <div className="stats-container">
           
            <div className="stat-box overall-box">
              <h3>Overall</h3>
              <p> {data.overall.total_count}</p>
              <p> ₹{data.overall.total_amount.toLocaleString()}</p>
            </div>

           
            {data.stats.map((stat, index) => (
              <div key={index} className="stat-box">
                <h4>{stat.status}</h4>
                <p> {stat.total_count}</p>
                <p> ₹{stat.total_amount.toLocaleString()}</p>
              </div>
            ))}
          </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Stats;
